import { CrudService } from './CrudService';
import { AxiosPromise } from 'axios';
import { resources } from '../resources';
import { AxiosConfig } from './BaseService';
import { SafetyEquipmentQueryParams } from '../params/SafetyEquipmentQueryParams';
import { SafetyEquipmentDto } from '../models/invitation/SafetyEquipmentDto';
import { SafetyEquipmentDtoUpdate } from '../models/invitation/SafetyEquipmentDtoUpdate';
import { WorkplaceDto } from '../models/workplace/WorkplaceDto';

export class SafetyEquipmentService extends CrudService<SafetyEquipmentDto, SafetyEquipmentQueryParams, SafetyEquipmentDtoUpdate> {
  constructor() {
    super({
      query: resources.querySafetyEquipment,
      get: resources.getSafetyEquipment,
      create: resources.createSafetyEquipment,
      update: resources.updateSafetyEquipment,
      idKey: 'safetyEquipmentId',
    });
  }

  public async getWorkplacesForSafetyEquipment(safetyEquipmentId: string, options: AxiosConfig = {}): AxiosPromise<WorkplaceDto[]> {
    return this.get<WorkplaceDto[]>(resources.getWorkplacesForSafetyEquipment, { safetyEquipmentId: safetyEquipmentId }, options);
  }
}
